import Navbar from "../../../components/Navbar/Navbar";
import ThirtydaysProvidersList from "../components/ThirtydaysProvidersList/ThirtydaysProvidersList";

export default function ThirtydaysProviders() {
    return (
        <>
            <Navbar
                title="Thirty days Providers"
                titleTooltip="Providers on this list can write notes for sessions that took place more than 30 days ago. Everyone else can only write notes within 30 days of the session, except psych notes, which have no time limit."
            />
            <div className="page">
                <ThirtydaysProvidersList />
            </div>
        </>
    );
}
